module.exports = __webpack_public_path__ + "img/34.1cac6f67.jpg";